import Food from '@components/offer/models/Food';
import { Grid, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import FoodBaseButton from './FoodBaseButton';
import FoodPriceList from './price/FoodPriceList';
import FoodListItemRightIcon from './FoodListItemRightIcon';

interface FoodListItemProps {
    food: Food;
    onClick: (food: Food) => void;
}

const FoodListItem: React.FC<FoodListItemProps> = observer(({ food, onClick }) => {
    return (
        <FoodBaseButton food={food} onClick={onClick}>
            <Grid padding={1.5} container direction="column" justifyContent="center" alignItems="flex-start">
                <Typography
                    fontWeight={600}
                    variant='subtitle2'
                    textAlign={"start"}>
                    {food.name}
                </Typography>
                <Typography
                    variant='subtitle2'
                    color={"text.secondary"}
                    textAlign={"start"}
                    overflow={"hidden"}
                    textOverflow={"ellipsis"}
                    width={"100%"}
                    noWrap
                    height={19.22}
                    pr={1}>
                    {food.description}
                </Typography>
                <FoodPriceList food={food} />
                <FoodListItemRightIcon />
            </Grid>
        </FoodBaseButton>
    )
})

export default FoodListItem;